<template>
  <section class="primaryInfo">
    <a
      name="home"
      style="
        position: relative;
        top: -420px;
        display: block;
        height: 0;
        overflow: hidden;
      "
    ></a>
    <section class="information" style="overflow-y: scroll;">
      <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>

      <section class="innerBox">
        <NewsMenu :isActive="isActive"></NewsMenu>
        <NewsBar></NewsBar>
        <div class="info">
          <h1>A letter to the ToTok community</h1>
          <p>
            Dear ToTok Community, <br /><br />With reference to the rumors
            circulated today about ToTok, our team would like to share with you
            the following message:

            <br /><br />Thanks to the amazing support from all of you, in just a
            few months ToTok has connected tens of millions of users across
            hundreds of countries, making it the most downloaded app in the MENA
            region and one of the fastest-growing apps globally.

            <br /><br />Our international team of ToTok entrepreneurs are united
            by one goal: create a reliable and easy-to-use platform that enables
            families, friends and colleagues around the world to do what all of
            us love to do - communicate freely, beyond borders and without
            limits.

            <br /><br />As a young company, we are deeply humbled by the rapid
            growth and enthusiasm of our user base. We are delighted to see the
            everyday impact of ToTok on people's lives.

            <br /><br />"ToTok is a great help for all of us that have a family
            abroad. I am almost in tears as I could finally speak to my
            daughter," said Tanveer S., an expat working overseas.

            <br /><br />"Wonderful, Friendly and Convenient. I recommend ToTok
            to everyone looking for quality and satisfaction", another user,
            Lutheramani, wrote in the app store review.

            <br /><br />In fact, over 30,000 positive user reviews have been
            shared on the Apple and Google stores to date, in an unmistakable
            and consistent sign of trust and appreciation that we are so
            fortunate to receive from our users.

            <br /><br />To make all this possible, we have developed ToTok by
            putting our users at the center of our thoughts. We designed a
            friendly interface that allows people to make calls and send
            messages in a few simple taps. We built an advanced communications
            protocol to ensure high-quality and stable audio and video
            experience.

            <br /><br />Furthermore, we equipped ToTok with such high-security
            standards as AES256, TLS/SSL, RSA and SHA256, to diligently protect
            the user data. We also implemented a privacy framework that complies
            with the local and international legal requirements to safeguard our
            users at all times.

            <br /><br />As the ToTok momentum continues to grow, some new users
            have notified us they are unable to download our app in Google Play
            Store and Apple App Store.

            <br /><br />Indeed, ToTok is temporarily unavailable in these two
            stores due to a technical issue. While the existing ToTok users
            continue to enjoy our service without interruption, we would like to
            inform our new users that we are well engaged with Google and Apple
            to address the issue.

            <br /><br />For our new users with Samsung, Huawei, Xiaomi and Oppo
            phones, ToTok is available in the phone maker's app store. All other
            Android users can install the ToTok app from our official website
            <span v-show="isAndriod"
              >(<span
                style="
                  cursor: pointer;
                  font-weight: 800;
                  text-decoration: underline;
                  color: #4378f2;
                "
                @click="downloadAppHandle"
                >click here</span
              >)</span
            >
            as a temporary solution.

            <br /><br />We have worked incredibly hard to deliver one of the
            best apps in the market. We promise to work even harder to enhance
            ToTok, with many new features that our users have requested, such as
            payment, news, commerce and entertainment, in the near future.

            <br /><br />Thank you for giving us the opportunity to serve you.

            <br /><br />Your ToTok Team
          </p>
        </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
    <FootBanner></FootBanner>
  </section>
</template>

<script>
import NewsBar from "@/components/NewsBar.vue";
import NewsMenu from "@/components/NewsMenu.vue";
import FootBanner from "@/components/FootBanner.vue";
import NavCrumbs from "@/components/NavCrumbs.vue";
import Footer from "@/components/Footer.vue";
export default {
  metaInfo() {
    return {
      title: "News - ToTok Messenger",
      // meta: [{
      //     vmid: 'og:title',
      //     property: 'og:title',
      //     name: 'og:title',
      //     content: 'Terms of Use - ToTok Messenger',
      // },{
      //     vmid:"og:description",
      //     property: 'og:description',
      //     name: 'og:description',
      //     content: 'Enjoy FREE, FAST and FUN calling with your family and friends.'
      // },]
      meta: [
        { property: "og:title", content: "News - ToTok Messenger" },
        { property: "og:description", content: "News - ToTok Messenger" },
        { property: "og:url", content: "https://totok.ai/news-dec23" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NewsBar,
    NewsMenu,
    NavCrumbs,
    Footer,
    FootBanner,
  },
  data() {
    return {
      crumbProp: {
        label: "Recent News",
        type: "simple",
      },
      showinfo: false,
      isActive: "Dec23",
      leftMenus: [
        {
          title: "Jan 05",
          anchorId: "Jan05",
        },
        {
          title: "Dec 29",
          anchorId: "Dec29",
        },
        {
          title: "Dec 27",
          anchorId: "Dec27",
        },
        {
          title: "Dec 24",
          anchorId: "Dec24",
        },
        {
          title: "Dec 23",
          anchorId: "Dec23",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
    isAndriod() {
      let ua = window.navigator.userAgent.toLowerCase();
      let isAndroid =
        /linux; android/.test(ua) ||
        ua.indexOf("linux") > -1 ||
        ua.indexOf("android") >= 0;
      if (isAndroid) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    downloadAppHandle() {
      window.location.href =
        "https://static2.totok.ai/android/totok-pub-release_v1.9.13(453)_totok.apk";
    },
    gotoHandle(palice) {
      switch (palice) {
        case "Jan05":
          this.isActive = "Jan05";
          this.$router.push({ name: "newsJan05" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec29":
          this.isActive = "Dec29";
          this.$router.push({ name: "newsDec29" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec27":
          this.isActive = "Dec27";
          this.$router.push({ name: "newsDec27" });
          // this.mainPannel.scrollTo(0, 0)
          break;
        case "Dec24":
          this.isActive = "Dec24";
          this.$router.push({ name: "newsDec24" });
          // this.mainPannel.scrollTo(0, 0)
          break;
        case "Dec23":
          this.isActive = "Dec23";
          this.$router.push({ name: "newsDec22" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
      }
    },
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .primaryInfo {

        background: #fff;
        height: 84vh;
        // overflow:hidden;

        // .leftMenu {
        //     display none
        // }

        div {
            margin-left: 20px;
            margin-right: 20px;
        }
        .innerBox{
            padding-bottom: 50px;
        }

        .info {


            h1 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 40px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 86px;
        width: 100vw;
        background: #fff;
        overflow-y: hidden;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                width:800px;
                min-height: 83vh;
                overflow: auto;

                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: flex-start;
                    list-style none;

                    // .menu-item {
                    //     color: #979797;
                    //     margin-top: 30px;
                    //     cursor pointer;
                    //     text-decoration none;
                    //     font-size: 15px;
                    // }

                    // .menu-item:nth-child(1) {
                    //     margin-top: 0px;
                    // }

                    // .menu-item--active {
                    //     color: #000;
                    //     border-bottom: 2px solid #4377f2;
                    // }

                }
            }
        }

        .info {
            width: 550px;
            margin: 20px 0;
margin-bottom:60px;
            h1 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
